import { actionTypes } from "./action";

export const initState = {
  isLoggedIn: localStorage.getItem("isLoggedIn")
    ? localStorage.getItem("isLoggedIn") === "true"
        : false,
    isVerified: localStorage.getItem("isVerified")
        ? localStorage.getItem("isVerified") === "true"
        : false,
  authToken: localStorage.getItem("authToken")
    ? localStorage.getItem("authToken")
    : null,
  userData: localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null,
appDefaultSetting: localStorage.getItem("APPDEFAULTData")
        ? JSON.parse(localStorage.getItem("APPDEFAULTData"))
        : null,
  countries: [],
  registerRequestData: localStorage.getItem("registerRequestData")
    ? JSON.parse(localStorage.getItem("registerRequestData"))
    : null,
  resetPasswordRequestData: null,
  defaultAddress: localStorage.getItem("defaultAddress")
    ? JSON.parse(localStorage.getItem("defaultAddress"))
    : null,
  emailPhoneConfirmationModal: false, // It will generate a modal on home page to ask user to confirm email or phone
  openEmailPhoneOptionModal: false, // It will give the option to user Email, Phone or Both
  kycRequestData: null,
  ipData: null,
};

function reducer(state = initState, action) {
  switch (action.type) {
    case actionTypes.APP_FIRST_START:
      return {
        ...state,
        authToken: action.authToken,
        userData: action.userData,
      };
      case actionTypes.APP_DEFAULT:
      return {
        ...state,
        appDefaultSetting: action.appDefaultSetting,
      };
    case actionTypes.REGISTER_REQEUST:
      return {
        ...state,
        registerRequestData: action.registerRequestData,
      };
    case actionTypes.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        resetPasswordRequestData: action.resetPasswordRequestData,
      };
    case actionTypes.KYC_REQUEST:
      return {
        ...state,
        kycRequestData: action.kycRequestData,
      };
    case actionTypes.DEFAULT_ADDRESS:
      return {
        ...state,
        defaultAddress: action.defaultAddress,
      };
    case actionTypes.WebAPP_CONFIGURATION:
      return {
        ...state,
        webAppConfiguration: action.webAppConfiguration,
          };
    case actionTypes.VERIFY_USER:
        return {
            ...state,
            isVerified: action.isVerified,
        };
    case actionTypes.LOGIN_USER:
      return {
        ...state,
          isLoggedIn: true,
          isVerified: action.isVerified,
        userData: action.userData,
      };
    case actionTypes.LOGIN_SUCCESS:
      return {
        ...state,
        ...{ isLoggedIn: true },
      };
    case actionTypes.LOGOUT_SUCCESS:
      localStorage.clear();
      return {
          isLoggedIn: false,
          isVerified: false
      };
    case actionTypes.GET_COUNTRIES:
      return {
        ...state,
        countries: action.countries,
      };
    case actionTypes.FETCH_IP_DATA:
      return {
        ...state,
        ipData: action.ipData,
      };
    case actionTypes.EMAIL_PHONE_CONFIRMATION_MODAL:
      return {
        ...state,
        emailPhoneConfirmationModal: action.emailPhoneConfirmationModal,
      };

    case actionTypes.OPEN_EMAIL_PHONE_OPTION_MODAL:
      return {
        ...state,
        openEmailPhoneOptionModal: action.openEmailPhoneOptionModal,
      };

    default:
      return state;
  }
}

export default reducer;
